// src/lib/preview.js — UI changes being tried out on Travis's login first,
// before they roll out to every RGA user. Delete a check once its change ships.
import { useAuth } from '../context/AuthContext'

const PREVIEW_EMAILS = ['tnelson@rgagroup.net']

export function useIsPreview() {
  const { user } = useAuth()
  return PREVIEW_EMAILS.includes(user?.email?.toLowerCase())
}
